import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { RnaMutationUploadComponent } from "./rna-mutation-upload.component";
import { LucideAngularModule } from "lucide-angular";
import { RNAMutStatusClassPipe, RNAMutStatusTextPipe } from "../../pipes/rna-mutation-status.pipe";

@NgModule({
  declarations: [RnaMutationUploadComponent, RNAMutStatusClassPipe, RNAMutStatusTextPipe],
  imports: [CommonModule, FormsModule, TranslateModule, LucideAngularModule],
  exports: [RnaMutationUploadComponent],
})
export class RnaMutationUploadModule {}
